import {
  TabChatNormalIcon,
  TabChatPressIcon,
  TabCreateNormalIcon,
  TabCreatePressIcon,
  TabExploreNormalIcon,
  TabExplorePressIcon,
  TabHomeNormalIcon,
  TabHomePressIcon,
  TabMeNormalIcon,
  TabMePressIcon,
} from '@/icons'
import { MobileFooterTag } from '@/types/common'
import React, { FC } from 'react'

interface Props {
  type: MobileFooterTag
  activeColor?: string
  inactiveColor?: string
  className?: string
  active?: boolean
}

const AppFooterIcon: FC<Props> = ({ type, className, active }) => {
  switch (type) {
    case MobileFooterTag.Home:
      return active ? <TabHomePressIcon /> : <TabHomeNormalIcon />
    case MobileFooterTag.Explore:
      return active ? <TabExplorePressIcon /> : <TabExploreNormalIcon />
    case MobileFooterTag.Chat:
      return active ? <TabChatPressIcon /> : <TabChatNormalIcon />
    case MobileFooterTag.Create:
      return active ? <TabCreatePressIcon /> : <TabCreateNormalIcon />
    case MobileFooterTag.Profile:
      return active ? <TabMePressIcon /> : <TabMeNormalIcon />
    default:
      return null
  }
}

export default AppFooterIcon
